import { useSelector } from 'react-redux';
import Mustache from 'mustache';

import { selectCashierConfiguration } from '@cashier/cashier-data-access';
import { AmountInterval } from '@cashier/cashier-model';
import { getCurrencySymbol } from '@cashier/cashier-shared';

import { prepareFormula } from '../helpers';

interface UseBonusBanner {
  generateTitle: (amount: string, bonusConfiguration: AmountInterval) => string;
  generateCTA: (amount: string, bonusConfiguration: AmountInterval) => string;
}

export const useBonusBanner = (): UseBonusBanner => {
  const { currency } = useSelector(selectCashierConfiguration);

  const currencySymbol = getCurrencySymbol(currency);

  const generateTitle = (
    amount: string,
    bonusConfiguration: AmountInterval,
  ): string => {
    const amountExist = amount !== null && amount !== '';

    const formula = prepareFormula(bonusConfiguration, amount, null);

    return Mustache.render(bonusConfiguration.title.pattern, {
      ...bonusConfiguration,
      formula,
      attributes: {
        ...bonusConfiguration.attributes,
        volume: amountExist ? bonusConfiguration.attributes.volume : '',
      },
      reward: {
        ...bonusConfiguration.reward,
        from: amountExist ? bonusConfiguration.reward.from : '',
        to: amountExist ? bonusConfiguration.reward.to : '',
      },
      amount: amountExist ? amount : '',
      currency: 'currency',
    }).replaceAll('currency', `${amountExist ? currencySymbol : ''}`);
  };

  const generateCTA = (
    amount: string,
    bonusConfiguration: AmountInterval,
  ): string => {
    const amountExist = amount !== null && amount !== '';

    const formula = prepareFormula(bonusConfiguration, amount, currencySymbol);

    return Mustache.render(bonusConfiguration.description.pattern, {
      ...bonusConfiguration,
      attributes: {
        ...bonusConfiguration.attributes,
        volume: amountExist ? bonusConfiguration.attributes.volume : '',
      },
      amount: amountExist ? amount : '',
      currency: 'currency',
      formula,
    }).replaceAll('currency', `${currencySymbol}`);
  };

  return {
    generateTitle,
    generateCTA,
  };
};
